let audioContext = null;

function getAudioContext() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) {
    return null;
  }
  if (!audioContext) {
    audioContext = new Ctx();
  }
  return audioContext;
}

function playBeep(ctx) {
  const start = ctx.currentTime;
  [880, 1175].forEach((frequency, index) => {
    const offset = index * 0.13;
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();

    oscillator.type = "sine";
    oscillator.frequency.value = frequency;
    gain.gain.setValueAtTime(0.0001, start + offset);
    gain.gain.exponentialRampToValueAtTime(0.3, start + offset + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + offset + 0.2);

    oscillator.connect(gain);
    gain.connect(ctx.destination);
    oscillator.start(start + offset);
    oscillator.stop(start + offset + 0.22);
  });
}

export function unlockNotificationSound() {
  const ctx = getAudioContext();
  if (!ctx) {
    return Promise.resolve(false);
  }

  if (ctx.state === "running") {
    return Promise.resolve(true);
  }

  return ctx.resume().then(() => true).catch(() => false);
}

export function playNotificationSound() {
  const ctx = getAudioContext();
  if (!ctx) {
    return;
  }

  const run = () => playBeep(ctx);

  if (ctx.state === "suspended") {
    ctx.resume().then(run).catch(() => {});
    return;
  }

  run();
}
